export class BaseFormBuilder {
    public static dateValue(item){
        if(!item) {
            return item;}
        return new Date(item);
    }
}